import { Action } from 'redux';
import { put } from 'redux-saga/effects';

import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { BasketActions, BasketActionTypes } from '..';
import { ErrorAction } from 'store';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface SaveCurrentPageAction extends Action<BasketActionTypes.SAVE_CURRENT_PAGE> {
    currentPage: string;
}

export interface SaveCurrentPageActionStart extends Action<BasketActionTypes.SAVE_CURRENT_PAGE_START> {
}

export interface SaveCurrentPageActionSuccess extends Action<BasketActionTypes.SAVE_CURRENT_PAGE_SUCCESS> {
}

export interface SaveCurrentPageActionError extends ErrorAction<BasketActionTypes.SAVE_CURRENT_PAGE_ERROR> {
}

export const saveCurrentPage: (currentPage: string) => SaveCurrentPageAction = (currentPage: string) => ({
    type: BasketActionTypes.SAVE_CURRENT_PAGE,
    currentPage
});
saveCurrentPage[ACTION_CREATOR_NAME] = 'saveCurrentPage';

export type SaveCurrentPageFunc = (...args: Parameters<typeof saveCurrentPage>) => void;

export function* saveCurrentPageSaga({ currentPage }: SaveCurrentPageAction): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.SAVE_CURRENT_PAGE_START
    });

    try {
        yield api.hybris.saveCurrentPage(currentPage);

        yield put<BasketActions>({
            type: BasketActionTypes.SAVE_CURRENT_PAGE_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.SAVE_CURRENT_PAGE_ERROR,
            error: errorToBasketErrorModel(error, 'saveCurrentPageSaga')
        });

        return false;
    }
}